/* Breed list for the My dogs breed picker (assets/my-dogs.js). One breed per line, alphabetical.
 *
 * Built 2026-09-25 from the Breed Science "BSM List" (Oct 2021) with the renames in
 * "Dog Breed list Change.xlsx" applied ("Poodle - Toy" -> "Toy Poodle"). Duplicates were merged:
 * "Mixed breed (Dog)" and "Other - Mixed-breed Dog" -> "Mixed Breed", "Pit Bull - American Terrier"
 * -> "American Pit Bull Terrier", "Shar Pei" -> "Chinese Shar-Pei". "Other" is added by the picker.
 * Keep names to 60 characters or fewer (the service's limit).
 */
window.MyDogsBreeds = [
  "Abyssinian Terrier",
  "Afghan Hound",
  "Airedale Terrier",
  "Akita",
  "Akita Mix",
  "Alaskan Husky",
  "Alaskan Husky Mix",
  "Alaskan Malamute",
  "Alaskan Malamute Mix",
  "American Bulldog",
  "American Bulldog Mix",
  "American Bully",
  "American Cocker Spaniel",
  "American Cocker Spaniel Mix",
  "American Eskimo",
  "American Mastiff",
  "American Pit Bull Terrier",
  "American Pit Bull Terrier Mix",
  "American Staffordshire Bull Terrier",
  "American Staffordshire Terrier",
  "American Staffordshire Terrier Mix",
  "Anatolian Shepherd",
  "Anatolian Shepherd Mix",
  "Aussiedoodle",
  "Australian Blue Heeler",
  "Australian Cattle Dog",
  "Australian Cattle Dog Mix",
  "Australian Dingo",
  "Australian Labradoodle",
  "Australian Red Heeler",
  "Australian Shepherd",
  "Australian Shepherd Mix",
  "Basenji",
  "Basenji Mix",
  "Basset Hound",
  "Basset Hound Mix",
  "Beagle",
  "Beagle Mix",
  "Belgian Malinois",
  "Bernedoodle",
  "Bernese Mountain Dog",
  "Bichon Frise",
  "Bichon Frise Mix",
  "Bichpoo",
  "Black Labrador Retriever",
  "Black Mouth Cur",
  "Bloodhound",
  "Bluetick Coonhound",
  "Border Collie",
  "Border Collie Mix",
  "Boston Terrier",
  "Boston Terrier Mix",
  "Boxer",
  "Boxer Mix",
  "Brittany Spaniel",
  "Brittany Spaniel Mix",
  "Bull Boxer",
  "Bull Terrier",
  "Bulldog",
  "Bullmastiff",
  "Bullmastiff Mix",
  "Cairn Terrier",
  "Cairn Terrier Mix",
  "Cane Corso",
  "Cane Corso Mix",
  "Cardigan Welsh Corgi",
  "Catahoula Leopard Dog",
  "Catahoula Leopard Dog Mix",
  "Cavachon",
  "Cavalier King Charles Spaniel",
  "Cavalier King Charles Spaniel Mix",
  "Cavapoo",
  "Chihuahua",
  "Chihuahua Mix",
  "Chinese Crested",
  "Chinese Shar-Pei",
  "Chinese Shar-Pei Mix",
  "Chiweenie",
  "Chocolate Labrador Retriever",
  "Chorkie",
  "Chow Chow",
  "Chow Mix",
  "Cockapoo",
  "Cocker Spaniel",
  "Cocker Spaniel Mix",
  "Collie",
  "Collie Mix",
  "Coonhound",
  "Coonhound Mix",
  "Coton de Tulear",
  "Curly-Coated Retriever",
  "Dachshund",
  "Dachshund Mix",
  "Dalmatian",
  "Dalmatian Mix",
  "Doberman Mix",
  "Doberman Pinscher",
  "Dogue de Bordeaux",
  "Dutch Shepherd",
  "English Bulldog",
  "English Bulldog Mix",
  "English Mastiff",
  "English Pointer",
  "English Pointer Mix",
  "English Setter",
  "English Springer Spaniel",
  "Flat-Coated Retriever",
  "French Bulldog",
  "German Shepherd Dog",
  "German Shepherd Mix",
  "German Shorthaired Pointer",
  "German Shorthaired Pointer Mix",
  "Giant German Spitz",
  "Giant Schnauzer",
  "Golden Retriever",
  "Golden Retriever Mix",
  "Goldendoodle",
  "Great Dane",
  "Great Dane Mix",
  "Great Pyrenees",
  "Great Pyrenees Mix",
  "Greyhound",
  "Havanese",
  "Hound Mix",
  "Irish Wolfhound",
  "Italian Greyhound",
  "Jack Russell Terrier",
  "Jack Russell Terrier Mix",
  "Labradoodle",
  "Labrador Retriever",
  "Labrador Retriever Mix",
  "Large Munsterlander",
  "Lhasa Apso",
  "Lhasa Apso Mix",
  "Long Haired Chihuahua",
  "Long Haired Whippet",
  "Maltese",
  "Maltese Mix",
  "Maltipoo",
  "Mastiff",
  "Mastiff Mix",
  "Medium Poodle",
  "Miniature Australian Shepherd",
  "Miniature Australian Shepherd Mix",
  "Miniature Beagle",
  "Miniature Bull Terrier",
  "Miniature Bulldog",
  "Miniature Chihuahua",
  "Miniature Dachshund",
  "Miniature Dachshund Mix",
  "Miniature Goldendoodle",
  "Miniature Labradoodle",
  "Miniature Labrador Retriever",
  "Miniature Long Haired Dachshund",
  "Miniature Pinscher",
  "Miniature Pomeranian",
  "Miniature Poodle",
  "Miniature Poodle Mix",
  "Miniature Schnauzer",
  "Miniature Schnauzer Mix",
  "Miniature Smooth Haired Dachshund",
  "Miniature Wire Haired Dachshund",
  "Mixed Breed",
  "Morkie",
  "Mountain Cur",
  "Norfolk Terrier",
  "Old English Sheepdog",
  "Olde English Bulldogge",
  "Papillon",
  "Peekapoo",
  "Pekingese",
  "Pekingese Mix",
  "Pembroke Welsh Corgi",
  "Pitbull Mix",
  "Plott Hound",
  "Pointer",
  "Pomchi",
  "Pomeranian",
  "Pomeranian Mix",
  "Pomsky",
  "Poodle Mix",
  "Pug",
  "Pug Mix",
  "Puggle",
  "Rat Terrier",
  "Rat Terrier Mix",
  "Rhodesian Ridgeback",
  "Rhodesian Ridgeback Mix",
  "Rottweiler",
  "Rottweiler Mix",
  "Rough Collie",
  "Saint Bernard",
  "Saint Bernard Mix",
  "Samoyed",
  "Schnauzer Mix",
  "Schnoodle",
  "Sheepadoodle",
  "Sheltie Mix",
  "Shetland Sheepdog",
  "Shiba Inu",
  "Shih Tzu",
  "Shih Tzu Mix",
  "Shihpoo",
  "Shorkie",
  "Siberian Husky",
  "Siberian Husky Mix",
  "Silky Terrier",
  "Small German Spitz",
  "Small Munsterlander",
  "Smooth Collie",
  "Smooth Fox Terrier",
  "Soft Coated Wheaten Terrier",
  "Spaniel Mix",
  "Staffordshire Bull Terrier",
  "Standard German Spitz",
  "Standard Long Haired Dachshund",
  "Standard Manchester Terrier",
  "Standard Poodle",
  "Standard Schnauzer",
  "Standard Smooth Haired Dachshund",
  "Standard Wire Haired Dachshund",
  "Teacup Chihuahua",
  "Teacup Poodle",
  "Teacup Yorkshire Terrier",
  "Terrier",
  "Terrier Mix",
  "Toy American Eskimo",
  "Toy Australian Shepherd",
  "Toy Chihuahua",
  "Toy Fox Terrier",
  "Toy Manchester Terrier",
  "Toy Poodle",
  "Toy Schnauzer",
  "Treeing Walker Coonhound",
  "Vizsla",
  "Weimaraner",
  "Welsh Corgi",
  "Welsh Corgi Mix",
  "West Highland White Terrier",
  "Wire Fox Terrier",
  "Wirehaired Vizsla",
  "Yellow Labrador Retriever",
  "Yorkiepoo",
  "Yorkshire Terrier",
  "Yorkshire Terrier Mix",
  "Zuchon",
];
